// @ts-check


/**
 * @type  { ({key: string, question: string, answer: *})[] }
 */
export const consultInitData = [
    {
      "key": "info_name",
      "question" : "1. 기초사항 - 성함",
      "answer": ""
    },
    {
      "key": "info_tel",
      "question" : "1. 기초사항 - 의뢰인의 연락처",
      "answer": ""
    },
    {
        "key": "info_case",
        "question" : "1. 기초사항 - 의뢰인의 연락처",
        "answer": ""
    },
    {
        "key": "delator_name",
        "question" : "2. 고소인 - 성명",
        "answer": ""
    },
    {
        "key": "delator_ssn",
        "question" : "2. 고소인 - 주민등록번호",
        "answer": ""
    },
    {
        "key": "delator_address",
        "question" : "2. 고소인 - 주소",
        "answer": ""
    },
    {
        "key": "delator_number",
        "question" : "2. 고소인 - 전화번호",
        "answer": ""
    },

    {
        "key": "delator_email",
        "question" : "2. 고소인 - 이메일주소",
        "answer": ""
    },
    {
        "key": "delator_agent",
        "question" : "2. 고소인 - 미성년자의 친권자 등 법정대리인이 고소하는 경우",
        "answer": ""
    },
    {
        "key": "respondent_name",
        "question" : "3. 피고소인 - 성명",
        "answer": ""
    },
    {
        "key": "respondent_ssn",
        "question" : "3. 피고소인 - 주민등록번호",
        "answer": ""
    },
    {
        "key": "respondent_address",
        "question" : "3. 피고소인 - 주소",
        "answer": ""
    },
    {
        "key": "respondent_tell",
        "question" : "3. 피고소인 - 전화번호",
        "answer": ""
    },
    {
        "key": "respondent_info",
        "question" : "3. 피고소인 - 인적사항을 제대로 알지 못하고 있는 경우",
        "answer": ""
    },
    {
      "key": "drift",
      "question" : "4. 고소취지",
      "answer": ""
    },
    {
        "key": "actually",
        "question" : "5. 고소사실 - 당사자간 관계(고소인과 피고소인 사이의 관계)",
        "answer": ""
    },
    {
        "key": "details",
        "question" : "5. 고소사실 - 고소에 이르게 된 경위",
        "answer": ""
    },
    {
        "key": "criminal",
        "question" : "5. 고소사실 - 피고소인의 범죄사실",
        "answer": ""
    },
    {
        "key": "punishment",
        "question" : "5. 고소사실 - 피해의 심각성 및 강력한 처벌 희망의사",
        "answer": ""
    },
    {
        "key": "enquiry",
        "question" : "5. 고소사실 - 수사요망사항",
        "answer": ""
    },
    // {
    //     "key": "evidence_name",
    //     "question" : "6. 인적증거 - 성명",
    //     "answer": ""
    // },
    // {
    //     "key": "evidence_num",
    //     "question" : "6. 인적증거 - 주민등록번호",
    //     "answer": ""
    // },
    // {
    //     "key": "evidence_address",
    //     "question" : "6. 인적증거 - 주소",
    //     "answer": ""
    // },  {
    //     "key": "evidence_job",
    //     "question" : "6. 인적증거 - 직업",
    //     "answer": ""
    // },  {
    //     "key": "evidence_tel",
    //     "question" : "6. 인적증거 - 전화",
    //     "answer": ""
    // },  {
    //     "key": "evidence_contents",
    //     "question" : "6. 인적증거 - 입증하려는 내용",
    //     "answer": ""
    // },

    {
        "key": "personal",
        "question": "6.  인적증거",
        "answer": [{
            "date" : "",
            "agency" : "",
            "add" : "",
            "job" : "",
            "tel":"",
            "cont":""
        }]
    },


    {
        "key": "documentary",
        "question": "7.  증거서류",
        "answer": [{
            "date" : "",
            "agency" : "",
            "content" : "",
            "evidence" : "",
        }]
    },
    {
        "key": "documentary_file",
        "question": "7. 증거서류 파일",
        "answer":[""]
    },
    {
        "key": "exhibit",
        "question": "8.  증거물",
        "answer": [{
            "date" : "",
            "agency" : "",
            "content" : "",
            "evidence" : "",
        }]
    },
    {
        "key": "exhibit_file",
        "question": "8. 증거물 파일",
        "answer":[""]
    },

    {
      "key": "etc",
      "question" : "9. 기타 증거",
      "answer": ""
    },
    {
        "key": "incident_detail_1",
        "question": "10. 관련사건의 수사 및 재판 여부 - 이전에 같은 범죄사실로 다른 검찰청 또는 경찰서에 고소장 또는 신고를 한 사실이 있는지 ",
        "answer": ""
    },
    {
        "key": "incident_detail_2",
        "question": "10. 관련사건의 수사 및 재판 여부 -  현재 이 사건과 관련된 사건으로 피고소인이 또는 공범이 검찰청이나 경찰서에서 수사계속중인지",
        "answer": ""
    },
    {
        "key": "incident_detail_3",
        "question": "10. 관련사건의 수사 및 재판 여부 -  현재 이 사건과 관련된 사건으로 민사소송을 제기한 사실이 있는지",
        "answer": ""
    },
]

// // 참고용 코드로 주석으로 남겨둠.
// let consultMap = new Map()

// consultMap.set('sheet_couple_net_property',
// {
//   "key": "sheet_couple_net_property",
//   "question" : "재산명세표 - 부부 순재산의 합계(원)",
//   "answer": "0"
// })

// const consultArrToMap = () => {
//   consultMap = consultInitData.reduce((map, item) => {
//     return map.set(item.key, item)
//   }, new Map())

//   console.info(consultMap)
// }

// consultArrToMap()